import React from "react";

import { ensureString } from "@intelligems/ig-utils";
import { styled } from "@mui/material";

import { ButtonRoot } from "../components/ButtonRoot";
import { ExtraMessage } from "../components/ExtraMessage";
import { PriceSection } from "../components/PriceSection";
import { QuantityButtons } from "../components/QuantityButtons";
import { useQuantityButtonsContext } from "../context/QuantityButtonsContext";

export const QuantityButtonsWidget1 = () => {
  return (
    <QuantityButtons
      renderButton={({ button, selected, index }) => (
        <ButtonRoot
          key={index}
          button={button}
          selected={selected}
          renderContent={({
            button,
            unitDiscount,
            mode,
            discountedUnitPrice,
          }) => (
            <>
              <Message
                quantity={button.quantity}
                unitDiscount={unitDiscount}
                message={
                  button.extraMessage
                    ? ensureString(button.extraMessage)
                    : undefined
                }
                fullPriceMessage={button.fullPriceMessage}
                mode={mode}
              />
              <PriceSection
                discountedUnitPrice={discountedUnitPrice}
                button={button}
              />
            </>
          )}
        />
      )}
    />
  );
};

const Message = styled(ExtraMessage)(() => {
  const { widget } = useQuantityButtonsContext();
  const { device } = widget;
  return {
    minWidth: device === "desktop" ? 135 : 105,
  };
});
